var option = {
    animation: false,
    tooltip: {
        show: true,
        trigger: 'axis',
        alwaysShowContent: true,
        position: [0, 0],
        padding: 0,
        backgroundColor: 'transparent',
        textStyle: {
            fontSize: 8,
            color: '#626A75'
        },
        formatter: '',
        axisPointer: {
            type: 'cross',
            crossStyle: {
                type: 'solid'
            }
        },
        extraCssText: 'z-index: 0;right: 0;'
    },
    axisPointer: {
        snap: true,
        link: { xAxisIndex: 'all' },
        label: {
            backgroundColor: '#F2F6FF',
            color: '#308CDD',
            fontSize: 10
            // margin: 0,
            // padding: [0, -3]
        }
    },
    grid: [
        {
            left: 5,
            right: 60,
            top: 40,
            height: '50%'
        },
        {
            left: 5,
            right: 60,
            top: '56%',
            height: '12%'
        },
        {
            left: 5,
            right: 60,
            top: '70%',
            height: '12%'
        },
        {
            left: 5,
            right: 60,
            top: '84%',
            height: '12%'
        }
    ],
    xAxis: [
        {
            type: 'category',
            // data: data.times,
            scale: true,
            // boundaryGap: false,
            axisLabel: {
                show: false
            },
            axisLine: {
                show: false,
                onZero: false
            },
            axisTick: {
                show: false
            },
            axisPointer: {
                label: {
                    show: false
                }
            },
            splitLine: {
                show: false
            },
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax'
        },
        {
            type: 'category',
            gridIndex: 1,
            // data: data.times,
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisPointer: {
                label: {
                    show: false
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#d1d1d6'
                }
            }
        },
        {
            type: 'category',
            gridIndex: 2,
            // data: data.times,
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisPointer: {
                label: {
                    show: false
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#d1d1d6'
                }
            }
        },
        {
            type: 'category',
            gridIndex: 3,
            // data: data.times,
            position: 'bottom',
            axisLabel: {
                show: true,
                color: '#d1d1d6',
                fontSize: 10
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ADB1B6'
                }
            }
        }
    ],
    yAxis: [
        {
            position: 'right',
            scale: true,
            splitArea: {
                show: false
            },
            axisPointer: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: '#d1d1d6',
                    opacity: 0.25
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#d1d1d6'
                }
            },
            axisLabel: {
                color: '#ADB1B6',
                fontSize: 10
            }
        },
        {
            gridIndex: 1,
            position: 'right',
            splitNumber: 3,
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                onZero: false,
                lineStyle: {
                    color: '#d1d1d6'
                }
            },
            axisLabel: {
                color: '#ADB1B6',
                fontSize: 10
            }
        },
        {
            gridIndex: 2,
            position: 'right',
            splitNumber: 3,
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#d1d1d6'
                }
            },
            axisLabel: {
                color: '#ADB1B6',
                fontSize: 10
            },
            scale: true
        },
        {
            gridIndex: 3,
            position: 'right',
            splitNumber: 4,
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                onZero: false,
                lineStyle: {
                    color: '#d1d1d6'
                }
            },
            axisLabel: {
                color: '#ADB1B6',
                fontSize: 10
            },
            min: 'dataMin',
            max: 'dataMax'
        }
    ],
    dataZoom: [
        {
            type: 'inside',
            xAxisIndex: [0, 1, 2, 3],
            zoomLock: true,
            throttle: 0,
            start: 50,
            end: 100
        }
    ],
    series: []
};

export default option;



// WEBPACK FOOTER //
// ./src/controller/echartsOption/kline.js